import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '../Button/Button';
import BigNumber from 'bignumber.js';

interface Props {
    open: boolean
    onClose: Function,
    isUnstaking: boolean,
    amountAvailable: number,
    onConfirm: Function,
    getInputValue: Function,
    confirmIsLoading: boolean
}

function StakeDialog(props: Props) {
    const [inputValue, setInputValue] = useState(0);

    useEffect(() => {
        props.getInputValue(inputValue);
    }, [inputValue, props, props.getInputValue])

    return (
        <Dialog
            className='deposit-dialog'
            open={props.open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                {props.isUnstaking
                    ? 'Deposit CACTI NFTs'
                    : 'Withdraw CACTI NFTs'
                }
            </DialogTitle>
            <DialogContent>
                <div className='input-wrapper'>
                    <input
                        onChange={(ev: any) => setInputValue(ev.target.value)}
                        value={inputValue}
                        placeholder='0'
                        type="number"
                    />
                    <div className='input-wrapper-info'>
                        <span>CACTI</span>
                        <button className="button l-btn btn-chip" onClick={() => setInputValue(props.amountAvailable)}>
                            MAX
                        </button>
                    </div>
                </div>
                <div className='input-available'>
                    <span>{props.amountAvailable} CACTI Available</span>
                </div>
            </DialogContent>
            <DialogActions>
                <Button className="button l-btn" onClick={() => props.onClose()}>
                    <span>Cancel</span>
                </Button>
                <Button
                    isLoading={props.confirmIsLoading}
                    className="button btn-main"
                    disabled={new BigNumber(inputValue).isGreaterThan(props.amountAvailable) || new BigNumber(inputValue).isLessThanOrEqualTo(0)}
                    onClick={() => props.onConfirm()}>
                    <span>Confirm</span>
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default StakeDialog;
